import { createHook, createStore, type StoreActionApi } from 'react-sweet-state';

import { FEEDBACK_COLLECTOR_SUCCESS_FLAG_ID, type Flag } from '@atlassian/ptc-common';

interface FlagsState {
	flags: Flag[];
}

type StoreApi = StoreActionApi<FlagsState>;
type Actions = typeof actions;

const initialState: FlagsState = {
	flags: [],
};

const actions = {
	addFlag:
		(flag: Flag) =>
		({ getState, setState }: StoreApi): void => {
			let flagId = flag.id;

			if (flagId !== FEEDBACK_COLLECTOR_SUCCESS_FLAG_ID) {
				flagId = flag.id ? `${flag.id}.${Date.now()}` : Date.now();
			}

			const newFlag = {
				...flag,
				id: flagId,
				appearance: 'normal' as const,
			};

			setState({
				flags: [newFlag, ...getState().flags],
			});
		},

	removeFlag:
		(flagId: string | number) =>
		({ getState, setState }: StoreApi): void => {
			const flags = getState().flags.filter((flag) => flag && flag.id !== flagId);

			setState({ flags });
		},
};

const FlagStore = createStore<FlagsState, Actions>({
	initialState,
	actions,
});

export const useStandaloneFlags = createHook(FlagStore, {
	selector: (state) => state.flags,
});

export const useStandaloneFlagActions = createHook(FlagStore, {
	selector: null,
});
